import './css/App.css';
import Home from './pages/Home';
import { SnackbarProvider } from 'notistack';

function App() {
  return (
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <div className="App">
        <Home />
      </div>
    </SnackbarProvider>
  );
}

export default App;
